import { useCan } from "#modules/company/view/Can";
import {
  VALID_2D_FILES_ACCEPT,
  VALID_2D_FILES_EXTENSIONS,
  VALID_3D_FILES_ACCEPT,
  VALID_3D_FILES_EXTENSIONS,
} from "shared";

type Zone = "predict" | "search";

export const useValidFilesTypes = (zone: Zone) => {
  const is2DAllowedForCompany = useCan("twoD");

  const only3DFiles = zone === "search" || !is2DAllowedForCompany;

  const validExtensions = only3DFiles
    ? [...VALID_3D_FILES_EXTENSIONS]
    : [...VALID_3D_FILES_EXTENSIONS, ...VALID_2D_FILES_EXTENSIONS];

  const accept = only3DFiles
    ? { ...VALID_3D_FILES_ACCEPT }
    : { ...VALID_3D_FILES_ACCEPT, ...VALID_2D_FILES_ACCEPT };

  return { validExtensions, accept };
};
